import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  margin: 0 1rem;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

const Content = styled.div`
  max-height: 12.5rem;
`;

interface Props {
  title: string;
  children: any;
}

const ContentBox = ({ title, children }: Props) => {
  return (
    <Container>
      <Typography fontSize="1rem" fontWeight="500" mb="0.5rem">
        {title}
      </Typography>
      <Content>{children}</Content>
    </Container>
  );
};

export default ContentBox;
